import { ListChecks, Share2, Gift, HeartHandshake } from "lucide-react";

const STEPS = [
  { icon: ListChecks, title: "Scegli e condividi", text: "La mamma sceglie i capi e condivide il link della lista." },
  { icon: Gift, title: "Regala con il 15%", text: "Chiunque apre il link può regalare un capo, o tutta la lista, con lo sconto del 15%." },
  { icon: HeartHandshake, title: "Nessun doppione", text: "La mamma vede chi ha regalato cosa e cosa manca ancora." },
];

export const GiftSteps = ({ compact = false }) => (compact ? (
  <div data-testid="gift-steps" className="rounded-2xl bg-white border border-[#F0DDD3] px-3.5 py-3 space-y-1.5">
    <div className="text-[11px] uppercase tracking-widest text-[#C87D75]">Come funziona</div>
    {STEPS.map((s, i) => (
      <div key={s.title} data-testid={`gift-step-${i + 1}`} className="flex items-center gap-2 text-[12px] text-[#5C534E] leading-snug">
        <s.icon size={13} className="shrink-0 text-[#C87D75]" /> <span><strong className="text-[#2D2825]">{i + 1}. {s.title}:</strong> {s.text}</span>
      </div>
    ))}
  </div>
) : (
  <div data-testid="gift-steps" className={`grid gap-2 ${compact ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-3 sm:gap-3"}`}>
    {STEPS.map((s, i) => (
      <div key={s.title} data-testid={`gift-step-${i + 1}`}
        className="flex gap-3 items-start rounded-2xl bg-white border border-[#F0DDD3] px-3.5 py-3">
        <div className="shrink-0 w-8 h-8 rounded-full bg-[#F9ECE9] text-[#C87D75] flex items-center justify-center"><s.icon size={15} /></div>
        <div className="min-w-0">
          <div className="text-[13px] font-medium text-[#2D2825]"><span className="text-[#C87D75]">{i + 1}.</span> {s.title}</div>
          <div className="text-[12px] leading-snug text-[#5C534E] mt-0.5">{s.text}</div>
        </div>
      </div>
    ))}
  </div>
));

export const GiftStatus = ({ it }) => {
  const left = it.quantity - (it.gifted_qty || 0);
  if (it.fully_gifted) {
    return <span data-testid={`gift-status-${it.product_id}`} className="inline-flex rounded-full bg-[#EAF0EC] text-[#4E7363] text-[10px] sm:text-[11px] px-2 py-0.5">Già regalato</span>;
  }
  if (it.gifted_qty > 0) {
    return <span data-testid={`gift-status-${it.product_id}`} className="inline-flex rounded-full bg-[#FDF6E7] text-[#A87F2A] text-[10px] sm:text-[11px] px-2 py-0.5">Regalato in parte ({it.gifted_qty} su {it.quantity}) · ne {left === 1 ? "manca 1" : `mancano ${left}`}</span>;
  }
  return <span data-testid={`gift-status-${it.product_id}`} className="inline-flex rounded-full bg-[#F9ECE9] text-[#C87D75] text-[10px] sm:text-[11px] px-2 py-0.5">Da regalare</span>;
};

export const ShareHint = () => (
  <div className="flex items-center gap-1.5 text-[11px] text-[#8C7F78]"><Share2 size={12} /> Condividi il link con parenti e amici</div>
);
